import React, { useState, useEffect, useContext } from 'react';
import { Row, Col } from 'react-bootstrap'
import { MARITAL_STATUS_ADD, MARITAL_STATUS_ALL, MARITAL_STATUS_UPDATE } from '../../../api/Routes';
import Get from '../../../api/Get';
import Post from '../../../api/Post';
import Put from '../../../api/Put';
import { authContext } from '../../../context/AuthContext';
import { toBool } from '../../../utils/toBool';
import LoadingList from '../../../loader/LoadingList';

import '../../../styles/catalogos/catalogos.css'
import AddEstadoCivil from './AddEstadoCivil';
import EstadoCivilList from './EstadoCivilList';
import ComponentModalErrorSever from '../../../components/ComponentModalErrorSever';

function EstadoCivilIndex(){

    //Parametros para actualizar la tabla
    const [items, setItems] = useState([])
    const [initialValues, setInitialValues] = useState({name:''})
    const [loading, setLoading] = useState(false)

    const [showModalError, setShowModalError] = useState(false)
    const [errorServer, setErrorServer] = useState(null)
    const handleClose = () => setShowModalError(false)

    //Token de autentificación para los servicios
    const {auth} = useContext(authContext)

    useEffect(() => {
        setLoading(true)

        Get({url: MARITAL_STATUS_ALL, access_token: auth.data.access_token})
        .then((resp) => {
            //console.log(resp)
            setItems(resp.data.data.response.content)
            setLoading(false)
        })
        .catch((error) => {
            setShowModalError(true)
            if(error.response){
                setErrorServer(error.response)
            }
            setLoading(false)
        })
    }, [])

    const agregar = (values) => {
        values.active = true;
        values.companies = [auth.data.company]
        setLoading(true)
        Post({url: MARITAL_STATUS_ADD, data: values, header:true, access_token:auth.data.access_token})
        .then((response) => {
            //console.log(response)
            setItems(prev=>[...prev, response.data.data])
            setInitialValues({name:''})
            
            setLoading(false)  
            
        })                
        .catch((error) => {
            setShowModalError(true)
            if(error.response){
                setErrorServer(error.response)
            }
            setLoading(false)
        })

    }

    const editar = (values) =>{
        
        if(toBool(values.active)){
            values.companies.push(auth.data.company)
        }else{
            let arr = values.companies.filter(el => el.id !== auth.data.company.id)
            values.companies = arr
        }        

        Put({url: MARITAL_STATUS_UPDATE, data: values, header:true, access_token:auth.data.access_token})
        .then((response) => {
            //ok         
        })                
        .catch((error) => {
            setLoading(false)        
            setShowModalError(true)
            if(error.response){
                setErrorServer(error.response)
            }
        })
    }

    return(<>
        {loading && <LoadingList texto='' />}

        <div className="body">
            
            <Row>
                <Col xs="6" md="6">
                    {!loading && <AddEstadoCivil agregar={agregar} initialValues={initialValues} title="Añadir nuevo estado civil" />}
                </Col>
                <Col xs="6" md="6">
                    <EstadoCivilList items={items} 
                        editar={editar}
                        auth={auth}
                        url_update={MARITAL_STATUS_UPDATE}
                    />
                </Col>
            </Row>
        </div>
        <ComponentModalErrorSever 
            show={showModalError}
            handleClose={handleClose}
            error={errorServer}
        />
    </>)
}

export default EstadoCivilIndex